module.exports = __webpack_public_path__ + "img/9788952234070.98da21db.jpg";